const tabContainer = document.querySelector('.benefit_section_header_block');
const tabHeader = document.querySelectorAll('.benefit_section_header');
const tabBlock = document.querySelectorAll('.benefit_section_block');

tabContainer.addEventListener('click', function(e){
  const clicked = e.target.closest('.benefit_section_header');
  console.log(clicked);
  if(!clicked) return;

tabHeader.forEach( tH => tH.classList.remove('benefit_header--active'));
tabBlock.forEach( tB => tB.classList.remove('benefit_section_block--active'));
  
clicked.classList.add('benefit_header--active');
document.querySelector(`.benefit_section_tab--${ clicked.dataset.tab }`).classList.add('benefit_section_block--active');

  
});
